/*
 * Modified from:
 * Zenscroll 4.0.0
 * https://github.com/zengabor/zenscroll/
 */

const toY = (element: HTMLElement, y: number) => { element.scrollTop = y; };
const getY = (element: HTMLElement) => (element as any).scrollY || element.scrollTop;
const smoothScrollEnabled = (elem: HTMLElement) => 'getComputedStyle' in window
  && window.getComputedStyle(elem)['scroll-behavior' as any] === 'smooth';

export const scrollTo = (element: HTMLElement, targetY: number, defaultDuration = 250) => {
  if (defaultDuration === 0 || smoothScrollEnabled(element)) {
    toY(element, targetY);
    return;
  }

  const startY = getY(element);
  const distance = Math.max(0, targetY) - startY;
  const startTime = new Date().getTime();
  const duration = defaultDuration || Math.min(Math.abs(distance), defaultDuration);
  (function loopScroll() {
    setTimeout(() => {
      // Calculate percentage:
      const p = Math.min(1, (new Date().getTime() - startTime) / duration);
      // Calculate the absolute vertical position:
      const factor = p < 0.5 ? (2 * p * p) : (p * (4 - (p * 2))) - 1;
      const y = Math.max(0, Math.floor(startY + (distance * factor)));
      toY(element, y);
      if (p < 1) {
        loopScroll();
      }
    }, 9);
  }());
};
